import {
    BusinessTypeDistribution,
    DailyStatistic,
    MonthlyStatistic,
    OverviewStatistic,
    ProblemCategoryDistribution
} from '@idea2app/ai-work-order-service';
import { observable } from 'mobx';
import { BaseModel, toggle } from 'mobx-restful';
import { formatDate, Week } from 'web-utility';

import userStore from './User';

export class StatisticModel extends BaseModel {
    client = userStore.client;

    @observable
    accessor overview: OverviewStatistic | undefined;

    @observable
    accessor monthlyStats: MonthlyStatistic[] = [];

    @observable
    accessor dailyStats: DailyStatistic[] = [];

    @observable
    accessor businessTypeDistribution: BusinessTypeDistribution[] = [];

    @observable
    accessor problemCategoryDistribution: ProblemCategoryDistribution[] = [];

    @toggle('downloading')
    async getOverview() {
        const { body } =
            await this.client.get<OverviewStatistic>('statistic/overview');

        return (this.overview = body);
    }

    @toggle('downloading')
    async getMonthlyStatistic(month = formatDate(Date.now(), 'YYYY-MM')) {
        const { body } = await this.client.get<MonthlyStatistic[]>(
            `statistic/monthly/${month}`
        );
        return (this.monthlyStats = body);
    }

    @toggle('downloading')
    async getDailyStatistic(
        startDate = formatDate(Date.now() - Week, 'YYYY-MM-DD'),
        endDate = formatDate(Date.now(), 'YYYY-MM-DD')
    ) {
        const { body } = await this.client.get<DailyStatistic[]>(
            `statistic/daily?${new URLSearchParams({ startDate, endDate })}`
        );
        return (this.dailyStats = body);
    }

    @toggle('downloading')
    async getBusinessTypeDistribution() {
        const { body } = await this.client.get<BusinessTypeDistribution[]>(
            'statistic/distribution/business-type'
        );
        return (this.businessTypeDistribution = body);
    }

    @toggle('downloading')
    async getProblemCategoryDistribution() {
        const { body } = await this.client.get<ProblemCategoryDistribution[]>(
            'statistic/distribution/problem-category'
        );
        return (this.problemCategoryDistribution = body);
    }

    getAll() {
        return Promise.all([
            this.getOverview(),
            this.getMonthlyStatistic(),
            this.getDailyStatistic(),
            this.getBusinessTypeDistribution(),
            this.getProblemCategoryDistribution()
        ]).catch(console.error);
    }
}

export default new StatisticModel();
